module.exports = __webpack_public_path__ + "img/DBD-Verified_silver.e4dc5046.png";